import ProjectTreeRowCommon from "./ProjectTreeRowCommon";
import ProjectTreeRowLsr from "./ProjectTreeRowLsr";
import ProjectTreeRowParent from "./ProjectTreeRowParent";

const ProjectTreeRowWrapper = ({ rowObj, callbacks }) => {
	const rowType = rowObj.type;

	if (rowType === "summary") {
		return <ProjectTreeRowParent rowObj={rowObj} paddingLeft={0} fontSize={15} callbacks={callbacks} />;
	} else if (rowType === "object") {
		return <ProjectTreeRowParent rowObj={rowObj} paddingLeft={15} fontSize={14} callbacks={callbacks} />;
	} else if (rowType === "kats" && rowObj?.isParent === true) {
		return <ProjectTreeRowParent rowObj={rowObj} paddingLeft={0} fontSize={15} callbacks={callbacks} />;
	} else if (rowType === "vor" && rowObj?.isParent === true) {
		return <ProjectTreeRowParent rowObj={rowObj} paddingLeft={0} fontSize={15} callbacks={callbacks} />;
	} else if (rowType === "cost_summary" && rowObj?.isParent === true) {
		return <ProjectTreeRowParent rowObj={rowObj} paddingLeft={0} callbacks={callbacks} />;
	} else if (rowType === "kats" && rowObj?.isParent !== true) {
		return <ProjectTreeRowCommon rowObj={rowObj} callbacks={callbacks} />;
	} else if (rowType === "vor" && rowObj?.isParent !== true) {
		return <ProjectTreeRowCommon rowObj={rowObj} fontSize={15} callbacks={callbacks} />;
	} else if (rowType === "cost_summary" && rowObj?.isParent !== true) {
		return <ProjectTreeRowCommon rowObj={rowObj} callbacks={callbacks} />;
	} else if (rowType === "local") {
		return <ProjectTreeRowLsr rowObj={rowObj} callbacks={callbacks} />;
	}
};

export default ProjectTreeRowWrapper;
